import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  FiGrid, FiBook, FiUpload, FiDownload, FiCpu,
  FiUsers, FiSettings, FiLogOut, FiMenu, FiX, FiHome
} from 'react-icons/fi';
import ThemeSwitcher from './ThemeSwitcher';

const Sidebar = ({ onLogout }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const userData = localStorage.getItem('user');
  const user = userData ? JSON.parse(userData) : null;
  const role = user?.role;

  const workspaceLinks = [
    { path: '/', icon: <FiGrid />, label: 'Dashboard' },
    { path: '/notes', icon: <FiBook />, label: 'Notes Library' },
    { path: '/summarizer', icon: <FiCpu />, label: 'AI Summarizer' },
  ];

  if (role === 'student') {
    workspaceLinks.push(
      { path: '/upload', icon: <FiUpload />, label: 'Submit Request' },
      { path: '/requests', icon: <FiDownload />, label: 'My Requests' }
    );
  } else {
    workspaceLinks.push(
      { path: '/upload', icon: <FiUpload />, label: 'Upload Notes' }
    );
  }

  const managementLinks = [];
  if (role === 'teacher') {
    managementLinks.push(
      { path: '/requests', icon: <FiUsers />, label: 'Review Requests' }
    );
  } else if (role === 'admin') {
    managementLinks.push(
      { path: '/requests', icon: <FiUsers />, label: 'Review Requests' },
      { path: '/colleges', icon: <FiHome />, label: 'Manage Colleges' },
      { path: '/admin/users', icon: <FiUsers />, label: 'User Management' }
    );
  }

  return (
    <>
      {/* Mobile top trigger bar */}
      <div className="mobile-header-bar" style={{
        display: 'none',
        padding: '12px 16px',
        background: 'var(--bg-surface)',
        borderBottom: '1px solid var(--border-subtle)',
        position: 'sticky',
        top: 0,
        zIndex: 40,
        justifyBetween: 'space-between',
        alignItems: 'center'
      }}>
        <div className="logo" style={{ fontSize: '18px', fontWeight: '700', color: 'var(--primary)', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <FiBook /> Notebook
        </div>
        <button className="btn btn-ghost btn-sm" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <FiX size={20} /> : <FiMenu size={20} />}
        </button>
      </div>

      <aside className={`sidebar ${mobileOpen ? 'mobile-open' : ''}`}>
        <div>
          <div className="logo">
            <FiBook size={24} />
            <span>Notebook</span>
          </div>

          <nav className="nav-links">
            <div className="nav-section-label">Workspace</div>
            {workspaceLinks.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                onClick={() => setMobileOpen(false)}
              >
                <span className="nav-icon">{item.icon}</span>
                <span>{item.label}</span>
              </NavLink>
            ))}

            {managementLinks.length > 0 && (
              <>
                <div className="nav-section-label">Management</div>
                {managementLinks.map((item) => (
                  <NavLink
                    key={item.path + item.label}
                    to={item.path}
                    className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                    onClick={() => setMobileOpen(false)}
                  >
                    <span className="nav-icon">{item.icon}</span>
                    <span>{item.label}</span>
                  </NavLink>
                ))}
              </>
            )}

            <div className="nav-section-label">Account</div>
            <NavLink
              to="/profile"
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
              onClick={() => setMobileOpen(false)}
            >
              <span className="nav-icon"><FiSettings /></span>
              <span>Profile Settings</span>
            </NavLink>
          </nav>
        </div>

        <div className="sidebar-footer">
          <div style={{ marginBottom: '12px' }}>
            <ThemeSwitcher />
          </div>

          <button onClick={onLogout} className="nav-item text-muted" style={{ color: 'var(--danger)' }}>
            <span className="nav-icon"><FiLogOut /></span>
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;